module.exports = __webpack_public_path__ + "media/images/voice09-a1cfeb7eb40514b6bb38bdc587d53c71.jpg";